import Box from '@material-ui/core/Box';
import Slider from '@material-ui/core/Slider';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { GREEN_EQ, RED_EQ, YELLOW_EQ } from './EQMarker';

interface Props {
  onMinScaleChange: (minScale: number) => void;
  minScale: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  range: {
    backgroundColor: theme.palette.background.paper,
    display: 'grid',
    gridTemplateRows: 'auto auto 1fr auto',
    padding: '10px 5px',
    justifyItems: 'center',
  },
}));

export const EQRange = (props: Props) => {
  const classes = useStyles(props);

  return (
    <Box height="300px" className={classes.range}>
      <Typography variant="caption" id="discrete-slider" gutterBottom>
        最小震度
      </Typography>
      <Box marginBottom="10px">
        <Typography variant="body2" id="discrete-slider" gutterBottom>
          {props.minScale}度
        </Typography>
      </Box>
      <Slider
        onChange={(e, value) => props.onMinScaleChange(value as number)}
        orientation="vertical"
        value={props.minScale}
        aria-labelledby="eq-slider"
        valueLabelDisplay="auto"
        step={1}
        marks
        min={1}
        max={7}
      />
      <Box marginTop="10px">
        <Typography variant="caption">発生日時</Typography>
      </Box>
      <Box
        display="grid"
        gridTemplateColumns="16px auto"
        gridTemplateRows="15px 15px 15px"
        width="70px"
      >
        <Box bgcolor={RED_EQ} width="100%" height="100%" />
        <Typography variant="caption" align="center">
          10分以内
        </Typography>
        <Box bgcolor={YELLOW_EQ} width="100%" height="100%" />
        <Typography variant="caption" align="center">
          30分以内
        </Typography>
        <Box bgcolor={GREEN_EQ} width="100%" height="100%" />
        <Typography variant="caption" align="center">
          それ以降
        </Typography>
      </Box>
    </Box>
  );
};
